<template>
<div class="shopMobKnowledgeSetting box-shadow">
    <div class="setting form dialog-form" v-show="selectCom.name === 'knowledge'">
        <div class="settingHeader"><span>{{item.label}}</span><el-button type="text">查看教程</el-button></div>
        <el-form :model="item" :rules="rules" ref="formName" label-width="100px" class="demo-ruleForm" label-position="left" size="mini">
            <el-form-item label="标题栏">
                <el-radio-group v-model="item.isdisplaytitle">
                    <el-radio :label="1">显示</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="标题名称" prop="titlename" class="input">
                <el-input v-model.trim="item.titlename" maxlength="30" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="使用限制" class="no-margin">
                <el-checkbox v-model="item.isdisplayall">显示查看全部</el-checkbox>
            </el-form-item>
            <el-form-item label="商品来源" class="no-margin">
                <el-radio-group v-model="item.datasource" @change="setDataSourse">
                    <el-radio :label="2">手动选择</el-radio>
                    <el-radio :label="3">商品分组</el-radio>
                </el-radio-group>
                <div class="content" v-if="item.datasource==2">
                    <div class="el-upload__tip operateBar">
                        <el-button plain type="primary" @click="openShopDialog">选择商品</el-button>
                        <div class="tip">此页面最多显示前10个，已添加{{item.datalist.length}}个</div>
                    </div>
                    <SlickList lockAxis="y" v-model="item.datalist" :distance="5" :lockToContainerEdges="true" class="model-slickList">
                        <SlickItem v-for="(obj, index) in item.datalist" :index="index"  :key="index" class="model-slickItem">
                            <div class="model-itemBox">
                                <div class="data-list">
                                    <span><img v-lazy="obj.furl" alt=""></span>
                                    <span class="text-ellipse data-name">{{obj.objectname}}</span>
                                    <span>{{obj.kmctype | kmctype}}</span>
                                </div>
                                <div class="model-compBtn">
                                    <span class="el-icon-error delComp cursor operateComp" @click.stop="compDel(index)"></span>
                                </div>
                            </div>
                        </SlickItem>
                    </SlickList>
                </div>
                <div class="content" v-if="item.datasource==3">
                    <div class="el-upload__tip operateBar">
                        <span>选择商品</span>
                        <el-button type="text" @click="openShopDialog" class="tip">从商品分组中选择</el-button>
                    </div>
                    <div class="model-itemBox" v-if="item.tagname">
                        <div class="data-list">
                            <span class="text-ellipse data-name">{{item.tagname}}</span>
                        </div>
                    </div>
                    <div class="el-upload__tip">
                        <div class="tip">
                            <span>显示个数</span>
                            <el-input-number v-model="item.datacount" controls-position="right" :min="1" :max="10"></el-input-number>
                            <span>此页面最多展示组内前10个商品</span>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="列表样式" class="no-margin">
                <el-radio-group v-model="item.liststyle">
                    <el-radio label="detail">列表</el-radio>
                    <el-radio label="bigimage">大图</el-radio>
                    <el-radio label="smallimage">小图</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
    <shopGroup ref="shopGroup" @setShopGroup="setShopGroupList"></shopGroup>
    <shop ref="shop" @setShop="setShopList"></shop>
</div>
</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import ShopGroup from 'views/shopMgt/mob/page/dataComponents/shopGroup'
import Shop from 'views/shopMgt/mob/page/dataComponents/shop'
export default {
    name: 'shopMobKnowledgeSetting',
    data() {
        return {
            isVisited: false,
            item: {
                cominnerid: '',
                label: '知识商品',
                comtype: 'knowledge',
                isdisplaytitle: 1,
                titlename: '',
                isdisplayall: 1,
                datasource: 1,
                liststyle: 'detail',
                tagname: '',
                taginnerid: '',
                datacount: 2,
                datalist: []
            },
            rules: {},
            datalist: []
        }
    },
    mounted() {
        this.item = $.extend(true, {}, this.shopMob[this.selectCom.index])
        if (this.item.datasource === 3) {
            this.datalist = this.item.datalist
        }
    },
    methods: {
        setShopGroupList(row) {
            this.datalist = row.dataContent
            this.item.datalist = this.datalist.slice(0, this.item.datacount)
            this.item.taginnerid = row.innerid
            this.item.tagname = row.name
        },
        setShopList(datalist) {
            this.item.datalist = datalist
        },
        openShopDialog() {
            if (this.item.datasource === 2) {
                this.$refs.shop.openDialog(this.item.datalist)
            } else if (this.item.datasource === 3) {
                this.$refs.shopGroup.openDialog({innerid: this.item.taginnerid, name: this.item.tagname})
            }
        },
        setDataSourse() {
            this.datalist = []
            this.item.datalist = []
        },
        compDel(index) {
            this.item.datalist.splice(index, 1)
        },
        ...mapActions([
            'setShopMob'
        ])
    },
    filters: {
        kmctype: function (value) {
            switch (value) {
            case 1: return '图文'
            case 2: return '报告'
            case 4: return '视频'
            case 5: return '专题'
            }
        }
    },
    watch: {
        item: {
            handler: function() {
                let tmpList = $.extend(true, [], this.shopMob)
                let obj = $.extend(true, {}, this.item)
                if (obj.datasource === 3) {
                    obj.datalist = this.datalist.slice(0, obj.datacount)
                }
                tmpList.splice(this.selectCom.index, 1, obj)
                this.setShopMob(tmpList)
            },
            deep: true
        },
        selectCom: {
            handler: function() {
                this.item = $.extend(true, {}, this.shopMob[this.selectCom.index])
                this.datalist = this.item.datalist
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {
        SlickList, SlickItem, ShopGroup, Shop
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobKnowledgeSetting {
    .form{
        margin: 0;
    }
    position: absolute;
    top:0;
    left: 100%;
    margin-left: 10px;
    margin-top: 0;
    padding: 0 20px;
    .setting{
        .settingHeader{
            color: $tcolor-base;
            height: 40px;
            border-bottom: 1px solid $line;
            @include flexBox(space-between);
        }
    }
    .input .el-form-item__content{
        line-height: 1;
    }
    .el-input-number--mini{
        width: 66px;
        margin: 0 10px;
        .el-input--mini{
            width: 40px;
        }
        .el-input__inner{
            width: 66px;
            padding-right: 35px;
            text-align: left;
        }
    }
    .content{
        border: 1px solid $line;
        min-height: 60px;
        width: 400px;
        padding: 15px 10px;
        background: $bgcolor-white;
        .operateBar{
            margin-bottom: 15px;
            @include flexBox(flex-between);
            .tip{
                margin-left: 10px;
            }
        }
    }
    .model-slickList{
        .model-slickItem{
            cursor: move;
            box-sizing: border-box;
            margin-bottom:10px;
        }
        .model-slickItem:hover{
            box-sizing: border-box;
            background: $bgcolor-lightbase;
            .operateComp{
                display: inline-block;
            }
        }
    }
}
.model-itemBox{
    box-sizing: border-box;
    position: relative;
    font-size: 14px;
    img{
        width: 40px;
        height: 30px;
        display: block;
    }
    .operateComp{
        display: none;
        position: absolute;
        z-index: 100;
        top: -10px;
        font-size: 20px;
    }
    .delComp{
        color: $tcolor-grey;
        left: calc(100% - 10px);
    }
    .data-list{
        @include flexBox(flex-start);
        height: 30px;
        span{
            margin-right: 10px;
        }
        .data-name{
            max-width: 250px;
        }
    }
}
</style>
